<div class="ap-sign__mobile-app-skeleton">
    <ap-square-skeleton></ap-square-skeleton>
    <ap-paragraph-skeleton class="ap-sign__mobile-app-skeleton--explanation" [rows]="3"></ap-paragraph-skeleton>
</div>
